import React, { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const links = [
  { href: "#nosotros", label: "Nosotros" },
  { href: "#servicios", label: "Servicios" },
  { href: "#calidad", label: "Calidad" },
  { href: "#productos", label: "Productos" },
  { href: "#capacidad", label: "Capacidad" },
  { href: "#proceso", label: "Proceso" },
  { href: "#idi", label: "I+D" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/95 backdrop-blur-xl border-b border-slate-200 shadow-md"
          : "bg-white/90 backdrop-blur-xl border-b border-slate-200 shadow-sm"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/bskkmjte_1.png"
            alt="Global Nutralabs"
            className="h-11 md:h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-slate-600 hover:text-[#0A84E2] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#contacto"
            data-testid="nav-cta-contact"
            className="btn-brand inline-flex items-center gap-2 rounded-sm px-5 py-2.5 text-sm font-semibold"
          >
            Solicitar presupuesto
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-slate-800 p-2"
          aria-label="Menú"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200 shadow-lg">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-slate-700 hover:text-[#0A84E2] text-sm font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contacto"
              onClick={() => setOpen(false)}
              className="btn-brand rounded-sm px-5 py-3 text-sm font-semibold text-center"
            >
              Solicitar presupuesto
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
